export default "__VITE_ASSET__DTqizieO__"